import {
  TM_PL_RESULTS_FETCH_START,
  TM_PL_RESULTS_FETCH_SUCCESS,
  TM_PL_RESULTS_FETCH_ERROR,
  TM_PL_FINALIZE_START,
  TM_PL_FINALIZE_SUCCESS,
  TM_PL_FINALIZE_ERROR,
  TM_PL_ENABLE_RETAKE_START,
  TM_PL_ENABLE_RETAKE_SUCCESS,
  TM_PL_ENABLE_RETAKE_ERROR,
} from "../Actions/types";

const initial = {
  loading: false,
  error: null,
  rows: [],
  page: 0,
  totalPages: 0,
  totalElements: 0,
  finalizing: {}, // sessionId -> boolean
  enablingRetake: {}, // sessionId -> boolean
};

export default function teacherPlacementReducer(state = initial, action) {
  switch (action.type) {
    case TM_PL_RESULTS_FETCH_START:
      return { ...state, loading: true, error: null };

    case TM_PL_RESULTS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        rows: action.payload.rows,
        page: action.payload.page,
        totalPages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      };

    case TM_PL_RESULTS_FETCH_ERROR:
      return { ...state, loading: false, error: action.payload };

    case TM_PL_FINALIZE_START:
      return {
        ...state,
        finalizing: { ...state.finalizing, [action.payload.sessionId]: true },
      };

    case TM_PL_FINALIZE_SUCCESS: {
      const { sessionId } = action.payload;
      const { [sessionId]: _, ...rest } = state.finalizing;
      return { ...state, finalizing: rest };
    }

    case TM_PL_FINALIZE_ERROR: {
      const { sessionId } = action.payload;
      const { [sessionId]: _, ...rest } = state.finalizing;
      return { ...state, finalizing: rest, error: action.payload.error || state.error };
    }

    case TM_PL_ENABLE_RETAKE_START:
      return {
        ...state,
        enablingRetake: { ...state.enablingRetake, [action.payload.sessionId]: true },
      };

    case TM_PL_ENABLE_RETAKE_SUCCESS: {
      const { sessionId } = action.payload;
      const { [sessionId]: _, ...rest } = state.enablingRetake;
      return { ...state, enablingRetake: rest };
    }

    case TM_PL_ENABLE_RETAKE_ERROR: {
      const { sessionId } = action.payload;
      const { [sessionId]: _, ...rest } = state.enablingRetake;
      return { ...state, enablingRetake: rest, error: action.payload.error || state.error };
    }

    default:
      return state;
  }
}
